var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "product-detail__yt" }, [
    _c(
      "a",
      {
        staticClass: "product-detail__yt-modal-btn",
        attrs: {
          "data-toggle": "modal",
          "data-target": "#youtubeModal" + _vm._cid,
        },
        on: { click: _vm.playVideo },
      },
      [
        _c("lazy-img", {
          attrs: {
            "picture-class": "product-detail__yt-thumbnail",
            "image-url": "https://img.youtube.com/vi/" + _vm.videoId + "/0.jpg",
            alt: "youtube Thumbnail",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "modal fade youtube-modal",
        attrs: {
          id: "youtubeModal" + _vm._cid,
          tabindex: "-1",
          "aria-labelledby": "youtubeModalLabel",
          "aria-hidden": "true",
        },
      },
      [
        _c("div", { staticClass: "modal-dialog" }, [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-header" }, [
              _c("h5", { staticClass: "modal-title" }, [
                _vm._v(
                  _vm._s(_vm.$translate("OD3dprimaV2::Template.productVideos"))
                ),
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "close",
                  attrs: {
                    id: "closeButtonYoutube",
                    type: "button",
                    "data-dismiss": "modal",
                    "aria-label": "Close",
                  },
                  on: { click: _vm.stopVideo },
                },
                [
                  _c("span", { attrs: { "aria-hidden": "true" } }, [
                    _vm._v("×"),
                  ]),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-body" }, [
              _c(
                "div",
                {
                  ref: "iframe",
                  staticClass: "embed-responsive embed-responsive-16by9",
                },
                [
                  _c("iframe", {
                    staticClass: "embed-responsive-item vue--lazy-img",
                    attrs: {
                      "data-src": _vm.videoUrl,
                      frameborder: "0",
                      allow:
                        "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
                      allowfullscreen: "",
                    },
                  }),
                ]
              ),
            ]),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }